"use strict"; function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _pushjs = require('push.js'); var _pushjs2 = _interopRequireDefault(_pushjs);
var _reactrouterdom = require('react-router-dom');

var _bus = require('shared/services/bus'); var _bus2 = _interopRequireDefault(_bus);
var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _notification = require('web/services/notification');
var _wizard = require('web/services/wizard');
var _store = require('web/store');
var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _log = require('shared/log');
var _firstTimeTutorial = require('web/actions/firstTimeTutorial');
var _react = require('@sentry/react'); var Sentry = _interopRequireWildcard(_react);
var _app = require('web/services/app');
var _conversation = require('shared/selectors/conversation');
var _user = require('shared/selectors/user');
var _download = require('shared/services/download');
var _upgrade = require('shared/services/upgrade');
var _cookies = require('web/services/cookies');
var _downloadModalFlag = require('web/screens/onboardingShared/downloadModalFlag');
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);



/* SAFETY (every cast of `action` below): the bus hands each handler an
 * untyped action; a handler registered for a type narrows it to what that
 * action type carries. */











// Sentry
if (SENTRY_DSN) {
  _bus2.default.on("SERVER_ACK_SOCKET_CONNECTED", (action) =>
    Sentry.setUser({
      // SAFETY: registered for SERVER_ACK_SOCKET_CONNECTED (see top).
      id: (action ).userInfo.UserKey,
    }),
  )

  _bus2.default.on(_actionCreators2.default.logoutAction.type, () => Sentry.setUser({}))
}

_bus2.default.on('SESSION_EXPIRED', () => {
  _actions2.default.gotoLogin()
  _pushjs2.default.create("BloomText", {
    body: 'Your session has timed out.',
    icon: "assets/icons/logo-256x256.png",
    silent: true,
    onClick: function () {
      window.focus()
      this.close()
    },
  }).catch(() => null)
})

// The chat open in the inbox, whatever its scroll position.
const getOpenChatKey = () =>
  _optionalChain([_reactrouterdom.matchPath, 'call', _ => _(_store.history.location.pathname, { path: _routes2.default.INBOX.CHAT }), 'optionalAccess', _2 => _2.params, 'access', _3 => _3.wrappedKey])

// Notifications
_bus2.default.on(_actionCreators2.default.toastNotificationAction.type, (action, state) => {
  const currentUserKey = _user.selectCurrentUserKey.call(void 0, state)
  if (!_notification.hasBrowserPermission.call(void 0, ) || !_notification.getCookiePermission.call(void 0, currentUserKey)) return

  // SAFETY: registered for the Toast action type (see top).
  const { Type, Message, Sound, ExtraData } = (action ).payload
  const { blobjectKey, wrappedKey, wrappedType } = ExtraData

  // A failed scheduled message's notification comes as new_message too
  // (ExtraData.notifType scheduled_message_failed) and opens its chat.
  if (Type !== "new_message" && Type !== "reaction" && Type !== "mention") return

  // The chat you're reading stays silent: BloomText is the focused window and
  // that chat is open. Everything else gets a banner and sound.
  if (document.hasFocus() && getOpenChatKey() === wrappedKey) return

  if (Sound) playSound(Sound)
  _pushjs2.default.create("BloomText", {
    body: Message,
    icon: "assets/icons/logo-256x256.png",
    silent: true,
    onClick: function () {
      window.focus()
      _actions2.default.gotoBlobject(wrappedType, wrappedKey, blobjectKey)
      this.close()
    },
  }).catch(() => null)
})

const updateAppOnce = () => {
  const cookieName = 'autoUpdateCooldown'

  if (_cookies.readCookie.call(void 0, cookieName)) {
    _log.log.info("Ignoring this update because we updated recently")
    return
  }
  // The JS passed `true`; qs.stringify writes it as 'true' either way.
  _cookies.createCookie.call(void 0, cookieName, 'true', { seconds: 300 })
  _app.updateApp.call(void 0, )
}

_bus2.default.on('SERVER_ACK_SOCKET_CONNECTED', (untypedAction, state) => {
  // SAFETY: registered for SERVER_ACK_SOCKET_CONNECTED (see top).
  const action = untypedAction 
  _log.log.info(`Checking for a desktop update...`)
  if (_download.shouldDownloadUpgrade.call(void 0, )) {
    _log.log.info('Found a desktop update')
    _actions2.default.downloadAvailable()
    return
  }
  _log.log.info(`Checking for an update for ${VERSION}...`)
  if (!_upgrade.shouldAttemptUpgrade.call(void 0, action.buildConfig)) {
    _log.log.info("No update is available")
    return
  }
  _log.log.info(`Found an update to ${action.buildConfig.GitHash}`)
  if (_conversation.selectHasAnyDrafts.call(void 0, state)) {
    _log.log.info("Ignoring this update because we have drafts")
    _actions2.default.markAppOutdated()
    return
  }
  updateAppOnce()
})

_bus2.default.once(_actionCreators2.default.loginSuccessAction.type, untypedAction => { // Successful login
  // SAFETY: registered for the login success action type (see top).
  const { payload } = untypedAction 
  const { UserKey } = payload.User

  const isFirstLoginEver = payload.User.NumberOfLogins === 0
  // SAFETY: the login response's ChatPreload carries Chats, but its API type
  // does not declare it; it is read as in the JS.
  const isOneChatOnly = Object.keys((payload ).Chats).length === 1
  const isQuickLoginEnabled = payload.User.QuickLogin
  const hasQuickLoginBeenConsidered = _wizard.isUserAwareOfQuickLogin.call(void 0, UserKey)

  const tutorialQueue = []
  if (isFirstLoginEver) {
    // Sessions arriving from the onboarding continuation just saw the real
    // offer and land with exactly one dialog (the download prompt) — the
    // legacy first-login popups would stack a second one on top of it.
    if (!_downloadModalFlag.arrivedFromOnboarding.call(void 0, )) {
      // The SMS-interest variant of this popup is gone: the trial offer now
      // pitches patient messaging at signup, and the feature surfaces
      // (Directory, search, broadcast) raise UpgradeModal on attempt.
      tutorialQueue.push({ type: 'POPUP', id: 'FIRST_TIME_POPUP' })
    }

    if (isOneChatOnly) { tutorialQueue.push({ type: 'TOOLTIP', id: _firstTimeTutorial.firstTimeTooltipIds.FIRST_CHAT }) }
    tutorialQueue.push({ type: 'TOOLTIP', id: _firstTimeTutorial.firstTimeTooltipIds.CREATE_NEW_BUTTON })
    tutorialQueue.push({ type: 'TOOLTIP', id: _firstTimeTutorial.firstTimeTooltipIds.SWITCH_INBOX })
    tutorialQueue.push({ type: 'TOOLTIP', id: _firstTimeTutorial.firstTimeTooltipIds.PROFILE })
  }

  if (_notification.hasBrowserPermission.call(void 0, ) === null) { // Not explicitly blocked
    tutorialQueue.push({ type: 'SNACKBAR', id: 'ENABLE_NOTIFICATIONS_SUGGESTION' })
  }

  if (!isQuickLoginEnabled && !hasQuickLoginBeenConsidered) {
    tutorialQueue.push({ type: 'SNACKBAR', id: 'ENABLE_QUICK_LOGIN_SUGGESTION' })
  }

  _actions2.default.pushInteractablesQueue(tutorialQueue)
})

_bus2.default.once("SERVER_ACK_SOCKET_CONNECTED", (_action, state) => {
  _wizard.addUserToPreviousLoginsList.call(void 0, state.currentUser.UserKey)
})

_bus2.default.on("LEAVE_CHAT", () => _store.history.push('/chats'))

// The browser says the network is back: reconnect now instead of waiting out
// the backoff, or ping a socket that looks open in case it died meanwhile.
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => _client2.default.checkConnection())
}

function playSound (sound) {
  let notificationURL = sound || 'assets/sounds/notifications/ping.wav'
  if (!notificationURL.includes('assets')) {
    notificationURL = 'assets/sounds/notifications/' + notificationURL
  }
  const audio = new Audio(notificationURL)
  const played = audio.play()
  if (played !== undefined) {
    played.catch(e => _log.log.info("Couldn't play audio", notificationURL, e))
  }
}
